import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { SegmentedSpinnerModule } from '@libs/src/segmented-spinner/segmented-spinner.module';
import { ProfileCompletionWidgetDialogModule } from '@main-client/src/app/profile-completion-widget-dialog/profile-completion-widget-dialog.module';
import { ProfileCompletionWidgetModule } from '@main-client/src/app/profile-completion-widget/profile-completion-widget.module';

import { ProfileCompletionWidgetViewComponent } from '@main-client/src/app/profile-completion-widget-view/profile-completion-widget-view.component';

@NgModule({
  declarations: [ProfileCompletionWidgetViewComponent],
  exports: [ProfileCompletionWidgetViewComponent],
  imports: [
    FlexLayoutModule,
    CommonModule,
    MatDialogModule,
    MatTabsModule,
    ProfileCompletionWidgetModule,
    ProfileCompletionWidgetDialogModule,
    SegmentedSpinnerModule,
  ],
})
export class ProfileCompletionWidgetViewModule {}
